import React, { useContext } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import Markdown from "../../styles/Markdown";
import RelatedJobsList from "./RelatedJobsList";

const StyledVacancyListWrapper = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
  order: 3;

  @media (min-width: 992px) {
    order: unset;
    position: sticky;
    top: 0;
    padding-top: 3rem;
  }
`;

const ImageWrapper = styled.div`
  background-image: url(${(props) => props.img});
  background-size: cover;
  background-position: center;
`;

const StyledImages = styled.div`
  position: relative;
  min-height: 2100px;

  ${ImageWrapper}:nth-child(1) {
    width: 575px;
    height: 800px;
    position: absolute;
    top: 0;
    left: 0;
  }

  ${ImageWrapper}:nth-child(2) {
    width: 610px;
    height: 630px;
    top: 760px;
    right: -10px;
    position: absolute;
  }

  ${ImageWrapper}:nth-child(3) {
    width: 640px;
    height: 360px;
    top: 1405px;
    left: -15px;
    position: absolute;
  }

  ${ImageWrapper}:nth-child(4) {
    width: 275px;
    height: 300px;
    top: 1755px;
    left: 10px;
    position: absolute;
  }

  ${ImageWrapper}:nth-child(5) {
    width: 340px;
    height: 400px;
    top: 1705px;
    right: -70px;
    position: absolute;
  }
`;
const ImageColumn = styled.div`
  order: 2;
  max-width: 100%;
  overflow: hidden;

  @media (min-width: 992px) {
    order: unset;
    width: 50%;
  }

  position: relative;
  min-height: 2100px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  max-width: 100%;

  @media (min-width: 992px) {
    flex-direction: row;
  }

  ${(props) => props.dynamicStyles || ""}
`;

const LeftColumn = styled.div`
  order: 1;

  @media (min-width: 992px) {
    order: unset;
    width: 50%;
    padding-right: 2rem;
  }
`;

const StyledQuote = styled.div`
  padding: 25px 10px;
  &::before {
    width: 78px;
    height: 62px;
    margin-bottom: 45px;
    content: "";
    display: block;
    background: transparent
      url(https://jobs.drmartens.com/wp-content/themes/drmartens/dist/images/quote.svg)
      no-repeat 50% / cover;
  }
`;

function StaggeredImageGallery() {
  const {
    image = [],
    text,
    CSS,
    quote,
    uniqueId,
    wrapperClassName,
  } = useContext(ComponentContext);

  return (
    <Container
      className={classNames(wrapperClassName, "related-jobs-gallery")}
      dynamicStyles={CSS}
      id={uniqueId}
    >
      <LeftColumn className="jobs-column">
        <div className="text-wrapper">
          <Markdown>{text}</Markdown>
        </div>
        <StyledVacancyListWrapper className="related-jobs-wrapper">
          <RelatedJobsList />
        </StyledVacancyListWrapper>
      </LeftColumn>
      <ImageColumn className="image-column">
        <StyledImages>
          {image?.data?.length > 0 &&
            image?.data?.map((img) => (
              <ImageWrapper
                key={img.id}
                className="image-wrapper"
                img={img.url}
              />
            ))}
        </StyledImages>
        <StyledQuote className="quote-wrapper">
          <Markdown>{quote}</Markdown>
        </StyledQuote>
      </ImageColumn>
    </Container>
  );
}

export default observer(StaggeredImageGallery);
